<template>
  <section class="container mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-16">
    <div
      data-aos="fade-up"
      data-aos-duration="1200"
      data-aos-delay="600"
      class="competitors bg-[#F4F8FA] rounded-2xl py-6 md:py-[53px] px-4 md:px-20 flex flex-col lg:flex-row items-center gap-6 md:gap-10 lg:bg-[url('@/shared/assets/png/resources.png')] bg-no-repeat"
    >
      <div class="max-w-[764px] w-full h-auto">
        <h3
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="800"
          class="font-semibold text-2xl sm:text-3xl md:text-[42px] leading-9 md:leading-[58px] text-[#172026] mb-3 md:mb-5 text-center lg:text-left"
        >
          {{ $t("marketassist_resource") }}
        </h3>
        <p
          data-aos="fade-right"
          data-aos-duration="1000"
          data-aos-delay="1000"
          class="font-normal text-sm sm:text-xl text-[#36485C] leading-6 sm:leading-7 text-center lg:text-left mb-4"
        >
          {{ $t("marketassist_resource_description") }}
        </p>
        <img
          data-aos="fade-left"
          data-aos-duration="1000"
          data-aos-delay="1200"
          src="@/shared/assets/png/resources.png"
          alt="competitors"
          class="h-[253px] mx-auto lg:hidden -mb-10 lg:mb-0"
        >
      </div>
    </div>
  </section>
</template>

<style scoped>
.competitors {
  background-size: 273px;
  background-position: right 32px bottom -50px;
}
</style>
